import { Component, EventEmitter, Input, Output } from '@angular/core';
var SearchNoResultsComponent = /** @class */ (function () {
    function SearchNoResultsComponent() {
        this.btnClick = new EventEmitter();
    }
    SearchNoResultsComponent.prototype.btnClicked = function () {
        this.btnClick.emit();
    };
    SearchNoResultsComponent.decorators = [
        { type: Component, args: [{
                    selector: 'cov-search-no-results',
                    template: "<div class=\"m-search-no-results {{ modifier && 'm-search-no-results--' + modifier || modifier }}\"\r\n\t data-t-name=\"SearchNoResults\"\r\n\t [attr.data-t-decorator]=\"decorator\">\r\n\t<h2 class=\"m-search-no-results__no-result-headline\">{{noResultsTitle}}</h2>\r\n\t<cov-richtext [text]=\"noResultsText\"></cov-richtext>\r\n\t<cov-button\r\n\t\t*ngIf=\"showButton\"\r\n\t\t[text]=\"buttonText\"\r\n\t\t[modifier]=\"'primary'\"\r\n\t\t(click)=\"btnClicked()\">\r\n\t</cov-button>\r\n</div>\r\n"
                }] }
    ];
    SearchNoResultsComponent.propDecorators = {
        modifier: [{ type: Input }],
        decorator: [{ type: Input }],
        noResultsTitle: [{ type: Input }],
        noResultsText: [{ type: Input }],
        showButton: [{ type: Input }],
        buttonText: [{ type: Input }],
        btnClick: [{ type: Output }]
    };
    return SearchNoResultsComponent;
}());
export { SearchNoResultsComponent };
//# sourceMappingURL=search-no-results.component.js.map